import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import Alert from '@whitelabel/component-library/src/components/Alert';
import { fontWeight } from '@whitelabel/helpers/style/type';
import claimsPortalMessages from '../../helpers/messages/commonMsg';
import { useAgentSession } from '../../helpers/hooks/useAgentSession';

const SECONDS_PER_MINUTE = 60;

export const formatCountdown = (totalSeconds: number): string =>
  `${Math.floor(totalSeconds / SECONDS_PER_MINUTE)}:${String(totalSeconds % SECONDS_PER_MINUTE).padStart(2, '0')}`;

const StyledAgentSessionBanner = styled(Alert)`
  margin-bottom: 0;
  border: 0;
  border-radius: 0;

  [data-test-id='Alert-content'] {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    gap: 0.5rem 1.5rem;
    justify-content: space-between;
    font-size: 1rem;
  }
`;

const StyledCountdown = styled.span`
  font-weight: ${fontWeight('bold')};
  font-variant-numeric: tabular-nums;
`;

// Shown for the whole support agent session: whose claim this is and how long is left.
const AgentSessionBanner = ({ bookingID }: { bookingID?: string }): JSX.Element | null => {
  const { formatMessage } = useIntl();
  const { isAgentSession, isExpired, remainingSeconds } = useAgentSession();

  if (!isAgentSession || isExpired) return null;

  return (
    <StyledAgentSessionBanner color="warning" data-test-id="agent-session-banner">
      <span>{formatMessage(claimsPortalMessages.agentSessionBanner, { bookingID })}</span>
      {remainingSeconds !== undefined && (
        <StyledCountdown role="timer" data-test-id="agent-session-countdown">
          {formatCountdown(remainingSeconds)}
        </StyledCountdown>
      )}
    </StyledAgentSessionBanner>
  );
};

export default AgentSessionBanner;
